import "./ActivitiesDashboardLayout.scss";
import activitiesIcon from "../../Assets/Activities/activitiesIcon.svg";
import schoolIocn from "../../Assets/School/schoolIocn.svg";
import themeParkIcon from "../../Assets/SideBar/themeParkActive.svg";
import universityIcon from "../../Assets/University/universityIcon.svg";
import TutorImg from "../../Assets/Tutor/TutorImg.svg";
import search from "../../Assets/Tutor/searchIconGray.svg";
import cricket from "../../Assets/Activities/cricket.svg";
import basketball from "../../Assets/Activities/basketball-svg.png";
import footballImg from "../../Assets/Activities/footballImg.png";
import { Autocomplete, TextField } from "@mui/material";
import Box from '@mui/material/Box';
import ActivitiesMaps from "../../Components/ActivitiesMaps/ActivitiesMaps";
import ActivitiesCardsCarousel from "../../Components/ActivitiesCardsCarousel/ActivitiesCardsCarousel";
import { useLocation, useNavigate } from "react-router-dom";
import { API_END_POINTS, AUTHENTICATION, GLOBAL_CONSTANTS, FILTER_CONSTANT, ROUTES } from "../../Constants/Constants";
import { useEffect, useState, useRef, useMemo } from "react";
import { axiosInstance } from "../../Utilities/Interceptor/Interceptor";
import { GetSessionStorageData, SetSessionStorageData, encryptPassData, isObjectEmptyValue, nullUndefinedEmptyCheck } from "../../Utilities/Helpers/Helper";
import { store } from "../../Redux/Store/Store";
import { setActivitiesFilter, setInitActivitiesFilter, setLoader } from "../../Redux/Reducer/Reducer";
import axios from "axios";
import ExpandMap from "../../Assets/Activities/ExpandMap.svg";
import { useSelector } from "react-redux";
import ActivitesCategoryPopup from "./ActivitesCategoryPopup/ActivitesCategoryPopup";
import AppFilter from "../../Components/AppFilter.tsx/AppFilter";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import { useMediaQuery, useTheme } from "@mui/material";

const ActivitiesDashboardLayout = () => {
  const activity_search = GetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.ACTIVITY);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState(activity_search ? activity_search : "");
  const [activitiesList, setActivitiesList] = useState<any>([]);
  const [searchTextList, setSearchTextList] = useState([]);
  const [currentLat, setCurrentLat] = useState<any>('');
  const [currentLang, setCurrentLang] = useState<any>('');
  const [FilterData, setFilterData] = useState<any>([]);
  const [IsTrigger, setIsTrigger] = useState<any>(null);
  const [zoomSize, setZoomSize] = useState<any>(12);
  const [Category, setCategory] = useState<any>([]);
  const [itemsToShow, setItemsToShow] = useState<any>(7);
  const [CategoryPopOpen, setCategoryPopOpen] = useState(false);
  const [promotionalContent, setPromotionalContent] = useState([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(490));

  const getActivityFilter: any = useSelector((state: any) => {
    return state.filterReducer?.activityfilter;
  });

  const init_ActivityFilter: any = useSelector((state: any) => {
    return state.initFilterReducer?.initActivityfilter;
  });

  const isLoaded: boolean = useSelector((state: any) => { // Added isLoaded from Redux
    return state.googleMapLoadedReducer.isGoogleMapLoaded; // Match the path from ActivitiesMaps
  });

  const init_filter = {
    activities: [],
    gender: [],
    price: [0, 0],
    age: [0, 0],
    experience: [0, 0],
    rating: 0,
    available: [],
    time: [0, 24],
    radius: 30
  };
  const [FilterPopOpen, setFilterPopOpen] = useState(false);
  const [initFilter, setInitFilter] = useState<any>(isObjectEmptyValue(init_ActivityFilter) ? init_ActivityFilter : init_filter);
  const [FilterApplyData, setFilterApplyData] = useState<any>(init_filter);
  const [initSort, setSort] = useState<any>({
    price: '',
    rating: ''
  });

  const lastPayloadRef = useRef<string | null>(null); 
  const searchCache = useRef(new Map<string, any>()); 

  const debounce = (func: Function, delay: number) => {
    let timeoutId: NodeJS.Timeout;
    return (...args: any[]) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  const onOpenFilterPop = () => {
    setFilterPopOpen(true);
  };

  const onCloseFilterPop = () => {
    setFilterPopOpen(false);
  };

  // const handleShowMore = () => {
  //   setCategoryPopOpen(true);
  // };

  const handleRouteMap = () => {
    navigate(ROUTES.ACTIVITY_MAPS_VIEW, {
      state: {
        activities_list: activitiesList,
        search_text: searchValue,
        redius: FilterApplyData.radius,
        lat: currentLat,
        lang: currentLang,
        filter: FilterApplyData,
        filterBoolean: IsTrigger,
      }
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const HeaderLoction: any = useSelector((state: any) => {
    return state.locationReducer.location;
  });

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        store.dispatch(setLoader(GLOBAL_CONSTANTS.INITIAL_VALUES.TRUE));

        const [promotionalResponse, filterResponse, categoriesResponse] = await Promise.all([
          axiosInstance.get(`${API_END_POINTS.PROMOTIONAL_CONTENT_LIST}?service_provider_type=2`),
          axiosInstance.get(`${API_END_POINTS.ACTIVITIES_FILTERLIST}`),
          axiosInstance.get(`${API_END_POINTS.ACTIVITIES_CATEGORIES}`),
        ]);

        if (promotionalResponse?.data?.status) {
          let data = promotionalResponse?.data?.result?.data;
          data.sort((a: any, b: any) => a.id - b.id);
          setPromotionalContent(data);
        }

        if (filterResponse?.data?.status) {
          let data = filterResponse?.data?.result?.data;
          setFilterData(data);
          if (data) {
            let init = {
              activities: [],
              price: [data.price?.min, data.price?.max],
              experience: [data.experience?.min, data.experience?.max],
              gender: [],
              rating: 0,
              age: [data.age?.min, data.age?.max],
              available: [],
              time: [0, 24],
              radius: 30,
            };
            store.dispatch(setInitActivitiesFilter(init));
            setInitFilter(init);
            SetSessionStorageData(FILTER_CONSTANT.INIT_FILTER.ACTIVITY, JSON.stringify(init));
            if (getActivityFilter && isObjectEmptyValue(getActivityFilter)) {
              setFilterApplyData(getActivityFilter);
            } else {
              setFilterApplyData(init);
            }
          }
        }

        if (categoriesResponse?.data?.status) {
          setCategory(categoriesResponse?.data?.result?.data);
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        store.dispatch(setLoader(GLOBAL_CONSTANTS.INITIAL_VALUES.FALSE));
      }
    };

    fetchInitialData();
  }, []);

  useEffect(() => {
    if (nullUndefinedEmptyCheck(HeaderLoction?.lat && HeaderLoction?.lng)) {
      const newLat = HeaderLoction?.lat;
      const newLng = HeaderLoction?.lng;
      const latChanged = String(newLat) !== String(currentLat);
      const lngChanged = String(newLng) !== String(currentLang);
      if (latChanged || lngChanged) {
        setCurrentLat(newLat);
        setCurrentLang(newLng);
        const filterToUse = getActivityFilter && isObjectEmptyValue(getActivityFilter) ? getActivityFilter : FilterApplyData;
        debouncedActivitiesListApi(newLat, newLng, searchValue, filterToUse);
      }
    }
  }, [HeaderLoction]);

  useEffect(() => {
    if (currentLat && currentLang) {
      const filterToUse = getActivityFilter && isObjectEmptyValue(getActivityFilter) ? getActivityFilter : FilterApplyData;
      debouncedActivitiesListApi(currentLat, currentLang, searchValue, filterToUse);
    }
  }, [FilterApplyData, searchValue]);

  const timeFormat = (value: number) => {
    if (value === 24) return `23:59`;
    const hours = Math.floor(value);
    const minutes = (value % 1) * 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  };

  const payload = (latitude: any, longitude: any, value: string, filter: any) => {
    let priceValue: any = [];
    let experienceValue: any = [];
    let ageValue: any = [];
    let timeValue: any = [];
    if (initFilter.price[0] === filter.price[0] && initFilter.price[1] === filter.price[1]) {
      priceValue = [];
    } else if (filter.price[0] === 0 && filter.price[1] === 0) {
      priceValue = [];
    } else {
      priceValue = {
        min: filter.price[0],
        max: filter.price[1],
      };
    }
    if (initFilter.experience[0] === filter.experience[0] && initFilter.experience[1] === filter.experience[1]) {
      experienceValue = [];
    } else if (filter.experience[0] === 0 && filter.experience[1] === 0) {
      experienceValue = [];
    } else {
      experienceValue = {
        min: filter.experience[0],
        max: filter.experience[1],
      };
    }
    if (initFilter.age[0] === filter.age[0] && initFilter.age[1] === filter.age[1]) {
      ageValue = [];
    } else if (filter.age[0] === 0 && filter.age[1] === 0) {
      ageValue = [];
    } else {
      ageValue = {
        min: filter.age[0],
        max: filter.age[1],
      };
    }
    if (initFilter.time[0] === filter.time[0] && initFilter.time[1] === filter.time[1]) {
      timeValue = [];
    } else {
      timeValue = {
        min: timeFormat(filter.time[0]),
        max: timeFormat(filter.time[1]),
      };
    }
    return {
      latitude: latitude?.toString(),
      longitude: longitude?.toString(),
      radius: filter.radius,
      search: value ? value : "",
      price: priceValue,
      experience: experienceValue,
      age: ageValue,
      time: timeValue,
      activities: filter.activities,
      gender: filter.gender,
      available: filter.available,
      rating: filter.rating,
    };
  };

  const ActivitiesListApi = (latitude: any, longitude: any, value: string, filter: any) => {
    const pay = payload(latitude, longitude, value, filter);
    const cacheKey = JSON.stringify(pay);

    if (lastPayloadRef.current === cacheKey) {
      return;
    }

    lastPayloadRef.current = cacheKey;

    axiosInstance
      .post(`${API_END_POINTS.ACTIVITIESLIST}`, pay)
      .then((Response: any) => {
        setActivitiesList(Response?.data?.result?.data);
        setZoomSize(10);
        setTimeout(() => {
          setZoomSize(12);
        }, 1000);
      })
      .catch(() => {});
  };

  const debouncedActivitiesListApi = debounce(ActivitiesListApi, 500);

  const debouncedSearchActivitiesKeyword = debounce((value: string) => {
    const cacheKey = value.trim();
    if (searchCache.current.has(cacheKey)) {
      setSearchTextList(searchCache.current.get(cacheKey));
      return;
    }

    const searchPayload = {
      search_text: cacheKey,
      activity_tag: FilterApplyData?.activities ? FilterApplyData?.activities?.toString() : "",
    };

    axios
      .post(`${process.env.REACT_APP_BASE_BACKEND_API_URL + API_END_POINTS.ACTIVITIES_KEY_WORD_SEARCH}`, searchPayload)
      .then((response: any) => {
        const data = response?.data?.result?.data;
        searchCache.current.set(cacheKey, data);
        setSearchTextList(data);
      })
      .catch(() => {});
  }, 500);

  const onInputChange = (value: any) => {
    if (nullUndefinedEmptyCheck(value)) {
      setSearchValue(value);
      debouncedSearchActivitiesKeyword(value);
      SetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.ACTIVITY, value);
    } else {
      setSearchValue("");
      SetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.ACTIVITY, '');
    }
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (currentLat && currentLang) {
      debouncedActivitiesListApi(currentLat, currentLang, searchValue, FilterApplyData);
    }
  };

  const FilterApply = (filter: any) => {
    setFilterApplyData(filter);
    setIsTrigger(true);
    SetSessionStorageData(FILTER_CONSTANT.STATE_FILTER.ACTIVITY, JSON.stringify(filter));
    store.dispatch(setActivitiesFilter(filter));
    navigate(ROUTES.ACTIVITY_LIST_VIEW, {
      state: {
        activities_list: "",
        search_text: searchValue,
        filterBoolean: true,
        redius: filter.radius,
        lat: currentLat,
        lang: currentLang,
        map_show: false,
        filter: filter
      }
    });
  };

  const ActivityApiCall = () => {
    if (currentLat && currentLang) {
      debouncedActivitiesListApi(currentLat, currentLang, searchValue, FilterApplyData);
    }
  };

  // Called by ActivitiesMaps when user drags marker / selects a point
  const handleMapLocationChange = (newLat: number | string, newLng: number | string) => {
    setCurrentLat(newLat);
    setCurrentLang(newLng);
    const filterToUse = getActivityFilter && isObjectEmptyValue(getActivityFilter) ? getActivityFilter : FilterApplyData;
    // immediately re-fetch with new coordinates
    debouncedActivitiesListApi(newLat, newLng, searchValue, filterToUse);
  };

  const handlePassCoursecategory = (value: any) => {
    if (nullUndefinedEmptyCheck(value)) {
      setSearchValue(value);
      SetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.ACTIVITY, value);
      if (value?.includes('near me')) {
        navigate(ROUTES.ACTIVITY_LIST_VIEW, {
          state: {
            activities_list: "",
            search_text: value,
            filterBoolean: IsTrigger,
            redius: FilterApplyData.radius,
            lat: currentLat,
            lang: currentLang,
            map_show: true,
            filter: FilterApplyData,
          }
        });
      } else {
        navigate(ROUTES.ACTIVITY_LIST_VIEW, {
          state: {
            activities_list: "",
            search_text: value,
            filterBoolean: IsTrigger,
            redius: FilterApplyData.radius,
            lat: currentLat,
            lang: currentLang,
            map_show: false,
            filter: FilterApplyData
          }
        });
      }
    }
  };

  // const onCloseCategoryPop = () => {
  //   setCategoryPopOpen(false);
  // };

  const onNavigate = (content: any) => {
    let provider_id = content.provider_id;
    let type = content?.service_provider_type === 2 ? "personal" : "camp";
    if (nullUndefinedEmptyCheck(provider_id)) {
      navigate(ROUTES.ACTIVITY_DETAILE_VIEW + "?id=" + encryptPassData(provider_id) + '&type=' + encryptPassData(type));
    } else {
      navigate(ROUTES.ACTIVITY_LIST_VIEW, {
        state: {
          activities_list: "",
          search_text: "",
          redius: FilterApplyData.radius,
          lat: currentLat,
          lang: currentLang,
          map_show: false,
          filter: FilterApplyData,
          filterBoolean: IsTrigger,
        },
      });
    }
  };

  const [sortPrice, setSortPrice] = useState("");
  const [sortRating, setSortRating] = useState("");

  useEffect(() => {
    setSortRating(GetSessionStorageData("sort_rating") || "");
    setSortPrice(GetSessionStorageData("sort_price") || "");
    if (sortPrice || sortRating) {
      handleProceedSort(sortPrice, sortRating);
    }
  }, []);

  const handleProceedSort = (checkedPrice: any, checkedRating: any) => {
    if (checkedPrice === 'high') {
      const campData: any = [...activitiesList?.camp || []].sort((a: any, b: any) => b?.least_price - a?.least_price);
      const personalData: any = [...activitiesList?.personal || []].sort((a: any, b: any) => b?.least_price - a?.least_price);
      setActivitiesList({
        camp: campData,
        personal: personalData
      });
      setSort({
        price: checkedPrice,
        rating: checkedRating
      });
    } else if (checkedPrice === 'low') {
      const campData: any = [...activitiesList?.camp || []].sort((a: any, b: any) => a?.least_price - b?.least_price);
      const personalData: any = [...activitiesList?.personal || []].sort((a: any, b: any) => a?.least_price - b?.least_price);
      setActivitiesList({
        camp: campData,
        personal: personalData
      });
      setSort({
        price: checkedPrice,
        rating: checkedRating
      });
    } else if (checkedRating === 'high') {
      const campData: any = [...activitiesList?.camp || []].sort((a: any, b: any) => b?.least_rating - a?.least_rating);
      const personalData: any = [...activitiesList?.personal || []].sort((a: any, b: any) => b?.least_rating - a?.least_rating);
      setActivitiesList({
        camp: campData,
        personal: personalData
      });
      setSort({
        price: checkedPrice,
        rating: checkedRating
      });
    } else if (checkedRating === 'low') {
      const campData: any = [...activitiesList?.camp || []].sort((a: any, b: any) => a?.least_rating - b?.least_rating);
      const personalData: any = [...activitiesList?.personal ||[]].sort((a: any, b: any) => a?.least_rating - b?.least_rating);
      setActivitiesList({
        camp: campData,
        personal: personalData
      });
      setSort({
        price: checkedPrice,
        rating: checkedRating
      });
    }
  };

  const language: any = useSelector((state: any) => {
    return state.languageReducer.language;
  });

  const Search_icon_top = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "search_button_eng" : "search_button_arb";
  const RowOverideActivityLang = language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "RowOverideActivityLang_Eng" : "RowOverideActivityLang_Arab";
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleNavigate = (route: string, routeName: string) => {
    console.log(`Navigating to ${routeName} with route: ${route}`);
    navigate(route);
  };

  const containerStyleMemo = useMemo(() => ({
    width: '100%',
    height: '400px' // Explicit height to ensure the map has space to render
  }), []);

  const filterMemo = useMemo(() => 
    isObjectEmptyValue(getActivityFilter) ? getActivityFilter : FilterApplyData, 
    [getActivityFilter, FilterApplyData]
  );

  const initFilterMemo = useMemo(() => initFilter, [initFilter]);

  return (
    <>
      {/* <div className={`${CategoryPopOpen ? 'header_wrapper__blur' : ''}`}>
        {CategoryPopOpen && (
          <ActivitesCategoryPopup
            PopOpen={CategoryPopOpen}
            onClosePop={onCloseCategoryPop}
            currentLat={currentLat}
            currentLang={currentLang}
            CourseData={Category}
            FilterRadiusvalue={FilterApplyData.radius}
            FilterApplyData={FilterApplyData}
          />
        )}
      </div> */}

      <div className="activities__container">
        <div className="col-md-12">
          {isMobile ? (
            <Swiper
              slidesPerView="auto"
              spaceBetween={10}
              navigation={false}
              scrollbar={{ draggable: false }}
              modules={[Navigation, Scrollbar]}
              className="nav-swiper"
              style={{ overflow: "hidden" }}
            >
              <SwiperSlide style={{ width: "auto" }}>
                <div className="activities_Img_wapper">
                  <img draggable="false" src={activitiesIcon} alt="activitiesImg" width={24} height={24} />
                  <div className="activities__text">{t("Activities")}</div>
                </div>
              </SwiperSlide>
              <SwiperSlide style={{ width: "auto" }}>
                <button
                  className="activities_Img_wapper nav-button"
                  onClick={() => handleNavigate(ROUTES.SCHOOLLAYOUT, "Schools")}
                  title={t("Schools")}
                  style={{ width: "120px" }}
                >
                  <img draggable="false" src={schoolIocn} alt="Schools" width={20} height={20} />
                  <span className="nav-title" style={{ fontSize: '10px', marginTop: '5px' }}>{t("Schools")}</span>
                </button>
              </SwiperSlide>
              <SwiperSlide style={{ width: "auto" }}>
                <button
                  className="activities_Img_wapper"
                  onClick={() => handleNavigate(ROUTES.TUTORS, "Tutors")}
                  title={t("Tutors")}
                  style={{ width: "120px" }}
                >
                  <img draggable="false" src={TutorImg} alt="TutorImg" width={20} height={20} />
                  <span className="nav-title" style={{ fontSize: '10px', marginTop: '5px' }}>{t("Tutors")}</span>
                </button>
              </SwiperSlide>
              <SwiperSlide style={{ width: "auto" }}>
                <button
                  className="activities_Img_wapper"
                  onClick={() => handleNavigate(ROUTES.THEMEPARK__HOMEPAGE, "Parks & Events")}
                  title={t("Parks & Events")}
                  style={{ width: "120px" }}
                >
                  <img draggable="false" src={themeParkIcon} alt="ParksAndEventIcon" width={20} height={20} />
                  <span className="nav-title" style={{ fontSize: '10px', whiteSpace: "nowrap", marginTop: '5px' }}>{t("Parks & Events")}</span>
                </button>
              </SwiperSlide>
              <SwiperSlide style={{ width: "auto" }}>
                <button
                  className="activities_Img_wapper"
                  onClick={() => handleNavigate(ROUTES.UNIVERSITYLAYOUT, "Universities")}
                  title={t("Universities")}
                  style={{ width: "120px" }}
                >
                  <img draggable="false" src={universityIcon} alt="Universities" width={20} height={20} />
                  <span className="nav-title" style={{ fontSize: '10px', marginTop: '5px' }}>{t("Universities")}</span>
                </button>
              </SwiperSlide>
            </Swiper>
          ) : (
            <div className="activities_Img_wapper">
              <img draggable="false" src={activitiesIcon} alt="activitiesImg" />
              <div className="activities__text">{t("Activities")}</div>
            </div>
          )}
        </div>

        <div className={`${RowOverideActivityLang} row mb-2 row-overide-activity`}>
          <div className="col-lg-3 col-md-12 input-style-resp">
            <div className="search_field_wrapper">
              <div className="search__autocomplete">
                <form onSubmit={handleSubmit}>
                  <Autocomplete
                    freeSolo
                    popupIcon
                    id="free-solo-2-demo"
                    disableClearable={false}
                    value={searchValue}
                    clearIcon={false}
                    onChange={(e, value) => {
                      setSearchValue(value);
                      handlePassCoursecategory(value);
                      SetSessionStorageData(FILTER_CONSTANT.SEARCH_STATE.ACTIVITY, value);
                    }}
                    options={searchTextList?.map((option: any) =>
                      language === GLOBAL_CONSTANTS.LANGUAGES.ARABIC ? option?.arabic_tag_name : option?.tag)}
                    renderOption={(props, option) => (
                      <Box component='li' sx={[{ px: 0.5, py: 0.7 }]} {...props} className="notranslate" translate="no">
                        {option}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={t("Search for Activities")}
                        onChange={(inputChangeEvent: any) => {
                          onInputChange(inputChangeEvent.target.value.trim());
                        }}
                        onKeyDown={(e: any) => {
                          if (e.key === GLOBAL_CONSTANTS.INITIAL_VALUES.ENTER) {
                            if (searchValue.trim() === '') {
                              e.preventDefault();
                            } else {
                              handlePassCoursecategory(searchValue);
                              e.preventDefault();
                            }
                          }
                        }}
                        InputProps={{
                          ...params.InputProps,
                          type: 'text',
                        }}
                      />
                    )}
                  />
                  <img
                    draggable="false"
                    src={search}
                    alt="search"
                    className={Search_icon_top}
                    onClick={() => handlePassCoursecategory(searchValue)}
                  />
                </form>
              </div>
            </div>
          </div>
          <div className="col-lg-9 col-md-12 activity-filter-respons">
            <AppFilter
              FilterPopOpen={FilterPopOpen}
              onOpenPop={onOpenFilterPop}
              onClosePop={onCloseFilterPop}
              FilterData={FilterData}
              FilterApply={FilterApply}
              FilterApplyData={FilterApplyData}
              initFilter={initFilter}
              initSort={initSort}
              handleApplySort={handleProceedSort}
              type="activity"
              color="#F0962C"
            />
          </div>
        </div>

        <div className="body_scroll_container">
          <div className="row mt-md-4 mt-3">
            <div className="col-lg-7 col-md-12 activitiesSports__container">
              <div className="activitiesSports">
                {Category?.slice(0, itemsToShow).map((data: any, i: any) => (
                  <div className="activitiesSports_Img_wapper" key={i} onClick={() => handlePassCoursecategory(data?.category_name)}>
                    <img
                      draggable="false"
                      src={nullUndefinedEmptyCheck(data?.display_image) ? data?.display_image : cricket}
                      alt="cricket"
                      onError={(e: any) => { e.target.src = cricket; }}
                      className=""
                    />
                    <span>{data?.category_name}</span>
                  </div>
                ))}
                {Category?.length > itemsToShow ? (
                  <div className="show_more_category">{t("Show more")}</div>
                ) : ("")}
              </div>
              <div className="row mt-3 activitiesSports__contants">
                <div className="col-lg-4 col-md-12 col-sm-12 d-flex flex-column flex-column__text">
                  <div className="text_wapper">
                    <span className="Sweat">{t("Sweat")}</span><span className="out">{t("it Out")}</span>
                  </div>
                  {promotionalContent.length > 0 && promotionalContent.map((content: any, index: number) => {
                    if (index === 0) {
                      return (
                        <div className={`main_content ${imageLoaded ? "loaded" : "loading"}`} onClick={() => onNavigate(content)} key={index}>
                          <img
                            src={content.image}
                            alt=""
                            className="leftImg"
                            onError={(e: any) => { e.target.src = basketball; }}
                            onLoad={() => setImageLoaded(true)}
                          />
                          <div className={`discount__wapper ${imageLoaded ? "discount_wrap_one" : "loading_state"}`}>
                            <div className="discount__flex__column">
                              <div className="discount__text__contant notranslate">
                                {language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? content?.description : content?.description_ar}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>

                {promotionalContent.length > 0 && promotionalContent.map((content: any, index: number) => {
                  if (index > 0) {
                    return (
                      <div className="col-lg-4 col-sm-6" key={index}>
                        <div className="main_content" onClick={() => onNavigate(content)}>
                          <img
                            src={content.image}
                            alt=""
                            className="rightImg"
                            onError={(e: any) => { e.target.src = footballImg; }}
                          />
                          <div className="discount__wapper discount_wrap_two">
                            <div className="discount__flex__column">
                              <div className="discount__text__contant notranslate">
                                {language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? content?.description : content?.description_ar}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                  return null;
                })}
              </div>
            </div>
            <div className="col-lg-5 col-md-12">
              {currentLat && currentLang && isLoaded ? ( // Now isLoaded is defined
                <div className="ActivitiesMaps__container" style={{ height: '400px' }}> {/* Explicit height */}
                  <div className="ActivitiesMaps__view">
                    <ActivitiesMaps
                      zoom={zoomSize}
                      radius={FilterApplyData.radius * 1000}
                      lat={currentLat}
                      lang={currentLang}
                      containerStyle={containerStyleMemo}
                      disable={false}
                      zoomControl={true}
                      initSort={initSort}
                      clickableIcons={true}
                      draggable={true}
                      ActivitiesList={activitiesList}
                      getOneTutor={[]}
                      filter={filterMemo}
                      searchValue={searchValue}
                      initFilter={initFilterMemo}
                      onLocationChange={handleMapLocationChange}
                    />
                    <div className="activity__viewMap" onClick={handleRouteMap}>
                      <img src={ExpandMap} alt="ExpandMap" />
                      <span>{t("View on Map")}</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div>Loading map... Please ensure location and Google Maps API are set.</div> // Updated placeholder
              )}
            </div>
          </div>
          <div className="Activities__Near_sports">
            <ActivitiesCardsCarousel
              radius={FilterApplyData.radius * 1000}
              lat={currentLat}
              lang={currentLang}
              ActivityList={activitiesList}
              ActivityApiCall={ActivityApiCall}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ActivitiesDashboardLayout;